import { ActionType } from '@root/state/actions-types';
import { Action } from '@root/state/actions/inventory';
import { Dispatch } from 'react';

export const getIdSeller = (id: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.GET_ID_SELLER, payload: id });
  };
};
